<div class="dialog-header">
	<div class="header-title"><span style="font-size: 120%;">Send FeedBack</span></div>

	<button mat-button class="close-button-container" mat-dialog-close disableRipple="true">
		<mat-icon>clear</mat-icon>
	</button>
</div>

<div class="edit-block">

	<form #sendFeedBackForm="ngForm">
		<div class="form-block">
			<div class="form-row">
				<div class="field-block">
					<mat-form-field>
						<input matInput autocomplete="off" placeholder="Subject" type="text" [required]="true" minlength="3"
							[(ngModel)]="subjectString" name="subjectString">
					</mat-form-field>
				</div>
			</div>
			<div class="form-row">
				<div class="field-block">
					<mat-select *ngIf="feedBackType" [(value)]="feedBackType">
						<mat-select-trigger>{{feedBackType.title}}</mat-select-trigger>
						<mat-option *ngFor="let type of feedBackTypes" [value]="type" class="feedback-option">
							<span class="type-text">{{type.title}}</span>
						</mat-option>
					</mat-select>
				</div>
			</div>
			<div class="form-row">
				<div class="field-block">
					<mat-select [(value)]="feedBackPriority" sty>
						<mat-select-trigger>{{feedBackPriority}}</mat-select-trigger>
						<mat-option *ngFor="let priority of feedBackPriorities" [value]="priority" class="feedback-option">
							<span class="type-text">{{priority}}</span>
						</mat-option>
					</mat-select>
				</div>
			</div>

			<div class="form-row">
				<div class="field-block file-block">
					<div class="file-names">
						<div class="file" *ngFor="let file of files">
							<div class="file-name">
								<span>{{file?.name}}</span>
							</div>

							<span class="delete-icon" (click)="deleteFile(file)">
								<mat-icon>clear</mat-icon>
							</span>
						</div>
					</div>
					<p-fileUpload mode="basic" name="files" #filesForm [customUpload]="true"
						(uploadHandler)="uploadFile($event.files, filesForm)" [auto]="true" [multiple]="true"
						chooseLabel="Upload"></p-fileUpload>

				</div>
			</div>

			<div class="form-row">
				<div class="field-block">
					<mat-form-field>
						<textarea matInput placeholder="Notes (please add PO number here) " type="text" [(ngModel)]="message"
							name="notes"></textarea>
					</mat-form-field>

				</div>
			</div>

		</div>
		<div class="save-btn-block">
			<div class="flex-box">

			</div>
			<button mat-button class="save-btn" (click)="saveFeedBack()" [disabled]="!sendFeedBackForm.form.valid"
				tabindex="1" type="submit" [ngClass]="{'disabled-button': !sendFeedBackForm.form.valid}">
				<span *ngIf="!loadingSpinner">Send</span>
				<lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
			</button>
		</div>
	</form>
</div>
